import { FC } from 'react'
import { MyPaper } from '../../components/UI/MyPaper'
import { SettingsLicenseWidget } from '../../modules/widgets/SettingsLicenseWidget/SettingsLicenseWidget'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

export const SettingsLicense: FC = () => {
  return (
    <MyPaper>
      <BlockTitle label="Лицензия" back />
      <SettingsLicenseWidget />
    </MyPaper>
  )
}
